//
// What the user is shown once per release, newest release first.
//
// {
//   date: '2026-07-22',      // ISO day, groups the lines and identifies the release
//   noteKey: 'relNoteXxx',   // optional heads-up sentence above the list
//   featureKeys: ['relDashboard', 'relTasks'],
// }
//
// A feature line may be { key, icon } instead of a key: the icon is drawn ahead of
// the line in the same blue as the tiny frameless button it stands for.
//
// `date` is what onboarding.releaseSeen stores: never change a shipped one, and
// keep the array newest first. Keys live in dashboard.releaseNotes.
//
const releaseHighlights = [
  {
    date: '2026-10-16',
    featureKeys: ['relMenus'],
  },
  {
    date: '2026-10-04',
    featureKeys: [{ key: 'relCasesFilter', icon: '/images/svg/gui/filter.svg' }, 'relSecondFactor'],
  },
  {
    date: '2026-09-01',
    featureKeys: ['relCaseCreate'],
  },
  {
    date: '2026-08-27',
    featureKeys: ['relCaseAssign'],
  },
  {
    date: '2026-07-22',
    featureKeys: ['relDashboard'],
  },
];

export default releaseHighlights;
